// React & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Data Table
import CivilStatusTable from "../../DataTables/MasterData/CivilStatus/CivilStatusTable";

// Modals
import CreateCivilStatusModal from "../../UiKits/Modal/MasterData/CivilStatus/CreateCivilStatus";

const CivilStatusContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Civil Status"
        parent="Master Data / Personal Information"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Civil Status Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage civil status options used throughout the HRIS for
                  employee and applicant personal information.
                </P>
                <CreateCivilStatusModal />
                <CivilStatusTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CivilStatusContainer;
